export type TradingCharacteristicType = {
  id: string;
  name: string;
  orderIndex: number;
};

export enum TradingCharacteristicsEnum {
  RMKT = 'RMKT',
  RMQI = 'RMQI',
  MSGM = 'MSGM',
  MLTF = 'MLTF',
}

export const TRADING_CHARACTERISTICS: TradingCharacteristicType[] = [
  {
    id: 'RMKT',
    name: 'Regulated market open to all investors',
    orderIndex: 1,
  },
  {
    id: 'RMQI',
    name: 'Regulated market, or segment thereof, limited to qualified investors',
    orderIndex: 1,
  },
  {
    id: 'MSGM',
    name: 'MTF which is a SME growth market',
    orderIndex: 1,
  },
  {
    id: 'MLTF',
    name: 'MTF which is not a SME growth market',
    orderIndex: 1,
  },
];

export const ORDERED_TRADING_CHARACTERISTICS = TRADING_CHARACTERISTICS.sort((a, b) => a.orderIndex - b.orderIndex);
